<template>
  <div class="clear-kit">
    <div class="landing-page-edit-panel"
         v-if="isGM()">
      <div class="wrapper" :class="[{ 'active': landingPanel }]">
        <div class="landing-page-edit-settings" @click.prevent="landingPanel = !landingPanel"></div>
        <div v-if="editHistory === false">
          <div class="action-btn"
               @click.prevent="pageMetaEdit = true">Edit page meta</div>
          <div class="action-btn"
               v-if="pageEditMode === false"
               @click.prevent="pageEditSwitch()">Edit page content</div>
          <div class="action-btn"
               @click.prevent="activateEditHistory()">Page edit history</div>
        </div>
        <div v-if="editHistory === true">
          <div class="form-group">
            <div class="form-element">
              <label for="page-versions" class="form-label color-2-63">Page save history</label>
              <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                        :searchable = false
                        @input="changeLandingPage($event)"
                        :options="getPageVersionsForSelect()"
                        data-lpignore="true"
                        id="page-versions" />
            </div>
          </div>
        </div>
        <div class="action-btn-bottom">
          <div class="action-btn action-btn-save"
               v-if="pageEditMode === true"
               @click.prevent="updateLandingPage()">Save</div>
          <div class="action-btn action-btn-discard"
               @click.prevent="discardPageEdit()">Discard</div>
        </div>
      </div>
    </div>
    <div class="landing-page-wrapper hero-cta-section"
         v-show="!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())">
      <div class="landing-page-content">
        <div class="toggle-section-visibility"
             style="top: 20px;"
             v-if="pageEditMode && isGM()">
          <input type="checkbox"
                 class="form-control__checkbox"
                 id="showHero"
                 v-model="content.heroSection.hideSection" />
          <label for="showHero">Hide this section</label>
        </div>
        <div class="flex-section">
          <div class="left-section">
            <h1 class="section-title"
                v-html="content.heroSection.title"
                v-if="!pageEditMode"></h1>
            <textarea class="section-title"
                      v-if="pageEditMode && isGM()"
                      data-gramm_editor="false"
                      placeholder="Section title"
                      data-lpignore="true"
                      rows="1"
                      v-model="content.heroSection.title"
                      v-on:keydown="autoSize($event)">{{ content.heroSection.title }}</textarea>
            <div class="section-description">
              <div class="content"
                   v-html="content.heroSection.description"
                   v-if="!pageEditMode"></div>
              <textarea class="content"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section description"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.heroSection.description"
                        v-on:keydown="autoSize($event)">{{ content.heroSection.description }}</textarea>
            </div>
          </div>
          <div class="right-section">
            <div class="landing-page-lets-meet">
              <a :href="content.heroSection.button.url"
                 :title="content.heroSection.button.text"
                 class="section-action"
                 v-if="!pageEditMode">{{ content.heroSection.button.text }}</a>
              <div class="section-buttons-edit">
                <input class="landing-page-button-edit"
                       v-if="pageEditMode && isGM()"
                       data-gramm_editor="false"
                       placeholder="Button text"
                       data-lpignore="true"
                       rows="1"
                       v-model="content.heroSection.button.text" />
                <input class="landing-page-button-edit"
                       v-if="pageEditMode && isGM()"
                       data-gramm_editor="false"
                       placeholder="Button url"
                       data-lpignore="true"
                       rows="1"
                       v-model="content.heroSection.button.url" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-page-wrapper about-section landing-page-wrapper__gray"
         v-show="!content.aboutSection[0].hideSection || content.aboutSection[0].hideSection === 'null' || (pageEditMode && isGM())">
      <div class="landing-page-content">
        <div class="toggle-section-visibility"
             style="top: 20px;"
             v-if="pageEditMode && isGM()">
          <input type="checkbox"
                 class="form-control__checkbox"
                 id="showSection"
                 v-model="content.aboutSection[0].hideSection" />
          <label for="showSection">Hide this section</label>
        </div>
        <div class="flex-section">
          <div class="left-section">
            <h1 class="section-title"
                v-html="content.aboutSection[0].title"
                v-if="!pageEditMode"></h1>
            <textarea class="section-title"
                      v-if="pageEditMode && isGM()"
                      data-gramm_editor="false"
                      placeholder="Section title"
                      data-lpignore="true"
                      rows="1"
                      v-model="content.aboutSection[0].title"
                      v-on:keydown="autoSize($event)">{{ content.aboutSection[0].title }}</textarea>
            <div class="section-description">
              <div class="content"
                   v-html="content.aboutSection[0].text"
                   v-if="!pageEditMode"></div>
              <textarea class="content"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section description"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.aboutSection[0].text"
                        v-on:keydown="autoSize($event)">{{ content.aboutSection[0].text }}</textarea>
            </div>
            <div class="section-action-wrapper">
              <a :href="content.aboutSection[0].button.url"
                 :title="content.aboutSection[0].button.text"
                 class="section-action"
                 v-if="!pageEditMode">{{ content.aboutSection[0].button.text }}</a>
              <div class="section-buttons-edit">
                <input class="landing-page-button-edit"
                       v-if="pageEditMode && isGM()"
                       data-gramm_editor="false"
                       placeholder="Button text"
                       data-lpignore="true"
                       rows="1"
                       v-model="content.aboutSection[0].button.text" />
                <input class="landing-page-button-edit"
                       v-if="pageEditMode && isGM()"
                       data-gramm_editor="false"
                       placeholder="Button url"
                       data-lpignore="true"
                       rows="1"
                       v-model="content.aboutSection[0].button.url" />
              </div>
            </div>
          </div>
          <div class="right-section">
            <h1 class="section-title"
                v-html="content.aboutSection[1].title"
                v-if="!pageEditMode"></h1>
            <textarea class="section-title"
                      v-if="pageEditMode && isGM()"
                      data-gramm_editor="false"
                      placeholder="Section title"
                      data-lpignore="true"
                      rows="1"
                      v-model="content.aboutSection[1].title"
                      v-on:keydown="autoSize($event)">{{ content.aboutSection[1].title }}</textarea>
            <div class="section-description">
              <div class="content"
                   v-html="content.aboutSection[1].text"
                   v-if="!pageEditMode"></div>
              <textarea class="content"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section description"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.aboutSection[1].text"
                        v-on:keydown="autoSize($event)">{{ content.aboutSection[1].text }}</textarea>
            </div>
            <div class="section-action-wrapper">
              <a :href="content.aboutSection[1].button.url"
                 :title="content.aboutSection[1].button.text"
                 class="section-action"
                 v-if="!pageEditMode">{{ content.aboutSection[1].button.text }}</a>
              <div class="section-buttons-edit">
                <input class="landing-page-button-edit"
                       v-if="pageEditMode && isGM()"
                       data-gramm_editor="false"
                       placeholder="Button text"
                       data-lpignore="true"
                       rows="1"
                       v-model="content.aboutSection[1].button.text" />
                <input class="landing-page-button-edit"
                       v-if="pageEditMode && isGM()"
                       data-gramm_editor="false"
                       placeholder="Button url"
                       data-lpignore="true"
                       rows="1"
                       v-model="content.aboutSection[1].button.url" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-page-wrapper clients-section about-page"
         v-show="!content.clientSection.hideSection || content.clientSection.hideSection === 'null' || (pageEditMode && isGM())">
      <div class="landing-page-content">
        <div class="toggle-section-visibility"
             v-if="pageEditMode && isGM()">
          <input type="checkbox"
                 class="form-control__checkbox"
                 id="showClient"
                 v-model="content.clientSection.hideSection" />
          <label for="showClient">Hide this section</label>
        </div>
        <h1 class="section-title center"
            v-html="content.clientSection.title"
            v-if="!pageEditMode"></h1>
        <textarea class="section-title center"
                  v-if="pageEditMode && isGM()"
                  data-gramm_editor="false"
                  placeholder="Section title"
                  data-lpignore="true"
                  rows="1"
                  v-model="content.clientSection.title"
                  v-on:keydown="autoSize($event)">{{ content.clientSection.title }}</textarea>
        <div class="section-description center"
             v-html="content.clientSection.description"
             v-if="!pageEditMode"></div>
        <textarea class="section-description center"
                  v-if="pageEditMode && isGM()"
                  data-gramm_editor="false"
                  placeholder="Section description"
                  data-lpignore="true"
                  rows="1"
                  v-model="content.clientSection.description"
                  v-on:keydown="autoSize($event)">{{ content.clientSection.description }}</textarea>
        <div class="logos flex-section">
          <slick class="clients-slider"
                 v-if="slidesReady"
                 ref="slick"
                 :options="slickOptions">
            <a v-for="item in content.clientSection.logos"
               :href="item.url">
              <img :src="getImageFullPath(item.image)"
                   :alt="item.altImage">
            </a>
          </slick>
          <div class="landing-page-slider-change"
               @click.prevent="switchSliderModal()"
               v-if="pageEditMode"></div>
        </div>
      </div>
    </div>
    <div class="landing-page-wrapper how-it-works-section landing-page-wrapper__gray"
         v-show="!content.howItWorksSection.hideSection || content.howItWorksSection.hideSection === 'null' || (pageEditMode && isGM())">
      <div class="landing-page-content">
        <div class="toggle-section-visibility"
             v-if="pageEditMode && isGM()">
          <input type="checkbox"
                 class="form-control__checkbox"
                 id="showHIW"
                 v-model="content.howItWorksSection.hideSection" />
          <label for="showHIW">Hide this section</label>
        </div>
        <h1 class="section-title center"
            v-html="content.howItWorksSection.title"
            v-if="!pageEditMode"></h1>
        <textarea class="section-title center"
                  v-if="pageEditMode && isGM()"
                  data-gramm_editor="false"
                  placeholder="Section title"
                  data-lpignore="true"
                  rows="1"
                  v-model="content.howItWorksSection.title"
                  v-on:keydown="autoSize($event)">{{ content.howItWorksSection.title }}</textarea>
        <div class="list flex-section" v-if="!getDeviceType('mobile')">
          <div class="list-item" v-for="item in content.howItWorksSection.sections">
            <div class="list-item-icon">
              <div class="content"
                   :title="getHighImageAlt(item)"
                   v-bind:style="{ backgroundImage: getImage(getHighImage(item)) }">
                <span class="landing-page-image-upload"
                      @click.prevent.stop="activatePopup(item)"
                      v-if="pageEditMode && isGM()"></span>
              </div>
            </div>
            <div class="list-item-title">
              <div class="content"
                   v-html="item.title"
                   v-if="!pageEditMode"></div>
              <textarea class="content"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Title"
                        data-lpignore="true"
                        rows="1"
                        v-model="item.title"
                        v-on:keydown="autoSize($event)">{{ item.title }}</textarea>
            </div>
            <div class="list-item-description">
              <div class="content"
                   v-html="item.text"
                   v-if="!pageEditMode"></div>
              <textarea class="content"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Description"
                        data-lpignore="true"
                        rows="1"
                        v-model="item.text"
                        v-on:keydown="autoSize($event)">{{ item.text }}</textarea>
            </div>
          </div>
        </div>
        <div class="content-slider" v-if="getDeviceType('mobile')">
          <slick class="slider"
                 ref="contentSlick"
                 :options="slickOptionsContent">
            <div class="list-item" v-for="item in content.howItWorksSection.sections">
              <div class="list-item-icon">
                <div class="content"
                     :title="getHighImageAlt(item)"
                     v-bind:style="{ backgroundImage: getImage(getHighImage(item)) }">
                <span class="landing-page-image-upload"
                      @click.prevent.stop="activatePopup(item)"
                      v-if="pageEditMode && isGM()"></span>
                </div>
              </div>
              <div class="list-item-title">
                <div class="content"
                     v-html="item.title"
                     v-if="!pageEditMode"></div>
                <textarea class="content"
                          v-if="pageEditMode && isGM()"
                          data-gramm_editor="false"
                          placeholder="Title"
                          data-lpignore="true"
                          rows="1"
                          v-model="item.title"
                          v-on:keydown="autoSize($event)">{{ item.title }}</textarea>
              </div>
              <div class="list-item-description">
                <div class="content"
                     v-html="item.text"
                     v-if="!pageEditMode"></div>
                <textarea class="content"
                          v-if="pageEditMode && isGM()"
                          data-gramm_editor="false"
                          placeholder="Description"
                          data-lpignore="true"
                          rows="1"
                          v-model="item.text"
                          v-on:keydown="autoSize($event)">{{ item.text }}</textarea>
              </div>
            </div>
          </slick>
        </div>
      </div>
    </div>
    <div class="landing-page-wrapper subscribe-section"
         v-show="!content.subscribeSection.hideSection || content.subscribeSection.hideSection === 'null' || (pageEditMode && isGM())">
      <div class="landing-page-content">
        <div class="toggle-section-visibility"
             v-if="pageEditMode && isGM()">
          <input type="checkbox"
                 class="form-control__checkbox"
                 id="showSubscribe"
                 v-model="content.subscribeSection.hideSection" />
          <label for="showSubscribe">Hide this section</label>
        </div>
        <div class="flex-section">
          <div class="left-section">
            <h1 class="section-title center"
                v-html="content.subscribeSection.title"
                v-if="!pageEditMode"></h1>
            <textarea class="section-title center"
                      v-if="pageEditMode && isGM()"
                      data-gramm_editor="false"
                      placeholder="Section title"
                      data-lpignore="true"
                      rows="1"
                      v-model="content.subscribeSection.title"
                      v-on:keydown="autoSize($event)">{{ content.subscribeSection.title }}</textarea>
            <div class="section-description center"
                 v-html="content.subscribeSection.description"
                 v-if="!pageEditMode"></div>
            <textarea class="section-description center"
                      v-if="pageEditMode && isGM()"
                      data-gramm_editor="false"
                      placeholder="Description"
                      data-lpignore="true"
                      rows="1"
                      v-model="content.subscribeSection.description"
                      v-on:keydown="autoSize($event)">{{ content.subscribeSection.description }}</textarea>
          </div>
          <div class="right-section">
            <form class="subscribe-form center" name="form" method="POST" action="https://forms.sign-up.to/15008/3116">
              <div class="subscribe-form-group"
                   :class="[{ 'active': subscribeForm.firstname !== '' || subscribeForm.firstnameFocus, 'has-error': subscribeForm.isError }]">
                <label for="subscribe-form-firstname">First name</label>
                <input id="subscribe-form-firstname"
                       type="text"
                       name="title"
                       @focus="subscribeForm.firstnameFocus = true"
                       @blur="subscribeForm.firstnameFocus = false"
                       v-model="subscribeForm.firstname" />
              </div>
              <div class="subscribe-form-group"
                   :class="[{ 'active': subscribeForm.lastname !== '' || subscribeForm.lastnameFocus, 'has-error': subscribeForm.isError }]">
                <label for="subscribe-form-lastname">Last name</label>
                <input id="subscribe-form-lastname"
                       type="text"
                       name="title"
                       @focus="subscribeForm.lastnameFocus = true"
                       @blur="subscribeForm.lastnameFocus = false"
                       v-model="subscribeForm.lastname" />
              </div>
              <div class="subscribe-form-group"
                   :class="[{ 'active': subscribeForm.email !== '' || subscribeForm.emailFocus, 'has-error': subscribeForm.isError }]">
                <label for="subscribe-form-email">Email</label>
                <input id="subscribe-form-email"
                       type="email"
                       name="email"
                       @focus="subscribeForm.emailFocus = true"
                       @blur="subscribeForm.emailFocus = false"
                       v-model="subscribeForm.email" />
              </div>
              <button name="subscribe" type="submit" @click.prevent="subscribeMe()" class="subscribe-form-action">Subscribe</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-page-wrapper features-section landing-page-wrapper__gray about-page"
         v-show="!content.featuresSection.hideSection || content.featuresSection.hideSection === 'null' || (pageEditMode && isGM())">
      <div class="landing-page-content">
        <div class="toggle-section-visibility"
             v-if="pageEditMode && isGM()">
          <input type="checkbox"
                 class="form-control__checkbox"
                 id="showFeatures"
                 v-model="content.featuresSection.hideSection" />
          <label for="showFeatures">Hide this section</label>
        </div>
        <div class="feature-list">
          <div class="feature-item" v-for="(item, index) in content.featuresSection.items">
            <div class="feature-title"
                 v-html="item.title"
                 v-if="!pageEditMode && !getDeviceType('desktop')"></div>
            <textarea class="feature-title"
                      v-if="pageEditMode && isGM() && !getDeviceType('desktop')"
                      data-gramm_editor="false"
                      placeholder="Item title"
                      data-lpignore="true"
                      rows="1"
                      v-model="item.title"
                      v-on:keydown="autoSize($event)">{{ item.title }}</textarea>
            <div class="feature-image"
                 :class="[{ 'iframe': item.video }]"
                 :title="!item.video || item.video === '' ? item.altImage : ''"
                 v-bind:style="{ backgroundImage: getImage(item.image) }">
              <iframe id="player"
                      frameborder="0"
                      webkitAllowFullScreen
                      mozallowfullscreen
                      allowFullScreen
                      height="340"
                      width="600"
                      v-if="!pageEditMode && item.video"
                      :src="getVideoUrl(item.video)"></iframe>
              <label :for="'feature-image-upload-' + index"
                     v-if="pageEditMode && isGM()"
                     class="landing-page-image-upload"></label>
              <input type="file"
                     v-if="pageEditMode && isGM()"
                     @change="onFileChange($event, item, 'image')"
                     :id="'feature-image-upload-' + index" />
              <template v-if="!item.image || item.image === ''">
                <input type="text"
                       placeholder="Video url"
                       v-if="pageEditMode && isGM()"
                       class="landing-page-image-alt"
                       v-model="item.video" />
              </template>
              <template v-else>
                <input type="text"
                       placeholder="Alt image"
                       v-if="pageEditMode && isGM()"
                       class="landing-page-image-alt"
                       v-model="item.altImage" />
              </template>
            </div>
            <div class="feature-content">
              <div class="feature-title"
                   v-html="item.title"
                   v-if="!pageEditMode && getDeviceType('desktop')"></div>
              <textarea class="feature-title"
                        v-if="pageEditMode && isGM() && getDeviceType('desktop')"
                        data-gramm_editor="false"
                        placeholder="Item title"
                        data-lpignore="true"
                        rows="1"
                        v-model="item.title"
                        v-on:keydown="autoSize($event)">{{ item.title }}</textarea>
              <div class="feature-description"
                   v-html="item.description"
                   v-if="!pageEditMode"></div>
              <a class="feature-link"
                 :href="item.button.url"
                 :title="item.button.text"
                 v-if="!pageEditMode && item.button.text !== ''">{{ item.button.text }}</a>
              <textarea class="feature-description"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Item description"
                        data-lpignore="true"
                        rows="1"
                        v-model="item.description"
                        v-on:keydown="autoSize($event)">{{ item.description }}</textarea>
              <input class="landing-page-button-edit"
                     v-if="pageEditMode && isGM()"
                     data-gramm_editor="false"
                     placeholder="Button text"
                     data-lpignore="true"
                     rows="1"
                     v-model="item.button.text" />
              <input class="landing-page-button-edit"
                     v-if="pageEditMode && isGM()"
                     data-gramm_editor="false"
                     placeholder="Button url"
                     data-lpignore="true"
                     rows="1"
                     v-model="item.button.url" />
              <div class="landing-page-remove"
                   v-if="pageEditMode && isGM()"
                   @click.prevent="removeSection(content.featuresSection.items, index)"></div>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="landing-page-add-section"
               @click.prevent="addSection('features')"
               v-if="pageEditMode && isGM()">+ Add row</div>
        </div>
      </div>
    </div>
    <div class="landing-page-wrapper footer-cta-section landing-page-wrapper__blue about-page"
         v-show="!content.footerCTASection.hideSection || content.footerCTASection.hideSection === 'null' || (pageEditMode && isGM())">
      <div class="landing-page-content">
        <div class="toggle-section-visibility"
             v-if="pageEditMode && isGM()">
          <input type="checkbox"
                 class="form-control__checkbox"
                 id="showFooter"
                 v-model="content.footerCTASection.hideSection" />
          <label for="showFooter">Hide this section</label>
        </div>
        <div class="flex-section">
          <div class="left-section">
            <h1 class="section-title"
                v-html="content.footerCTASection.title"
                v-if="!pageEditMode"></h1>
            <textarea class="section-title"
                      v-if="pageEditMode && isGM()"
                      data-gramm_editor="false"
                      placeholder="Section title"
                      data-lpignore="true"
                      rows="1"
                      v-model="content.footerCTASection.title"
                      v-on:keydown="autoSize($event)">{{ content.footerCTASection.title }}</textarea>
            <div class="section-description"
                 v-html="content.footerCTASection.description"
                 v-if="!pageEditMode"></div>
            <textarea class="section-description"
                      v-if="pageEditMode && isGM()"
                      data-gramm_editor="false"
                      placeholder="Section description"
                      data-lpignore="true"
                      rows="1"
                      v-model="content.footerCTASection.description"
                      v-on:keydown="autoSize($event)">{{ content.footerCTASection.description }}</textarea>
          </div>
          <div class="right-section">
            <div class="cta-content">
              <div class="section-actions">
                <a :href="content.footerCTASection.button.url"
                   :title="content.footerCTASection.button.text"
                   class="section-action"
                   v-if="!pageEditMode">{{ content.footerCTASection.button.text }}</a>
                <div class="section-buttons-edit">
                  <input class="landing-page-button-edit"
                         v-if="pageEditMode && isGM()"
                         data-gramm_editor="false"
                         placeholder="Button text"
                         data-lpignore="true"
                         rows="1"
                         v-model="content.footerCTASection.button.text" />
                  <input class="landing-page-button-edit"
                         v-if="pageEditMode && isGM()"
                         data-gramm_editor="false"
                         placeholder="Button url"
                         data-lpignore="true"
                         rows="1"
                         v-model="content.footerCTASection.button.url" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-page-change-image" v-if="activePopup && pageEditMode && isGM()">
      <div class="modal-inner" ref="iconPopup">
        <h1>Upload icons for: {{ activePopup.title }}</h1>
        <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
        <div class="modal-item">
          <h2>Image (normal)</h2>
          <div class="modal-image"
               v-bind:style="{ backgroundImage: getImage(activePopup.image) }">
            <label for="popup-step-image-upload"
                   class="step-item-upload"></label>
            <input type="file"
                   @change="onFileChange($event, activePopup, 'image')"
                   id="popup-step-image-upload" />
          </div>
          <input type="text" v-model="activePopup.altImage" placeholder="Image alt" />
        </div>
        <div class="modal-item">
          <h2>Image (high contrast)</h2>
          <div class="modal-image"
               v-bind:style="{ backgroundImage: getImage(activePopup.imageHigh) }">
            <label for="popup-step-high-image-upload"
                   class="step-item-upload"></label>
            <input type="file"
                   @change="onFileChange($event, activePopup, 'imageHigh')"
                   id="popup-step-high-image-upload" />
          </div>
          <input type="text" v-model="activePopup.altImageHigh" placeholder="High contrast image alt" />
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="landing-page-change-image" v-if="sliderModalShown && pageEditMode && isGM()">
      <div class="modal-inner" ref="sliderPopup">
        <h1>Change slider items</h1>
        <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
        <div class="logos">
          <div class="logo-item" v-for="(item, index) in content.clientSection.logos">
            <div class="modal-item">
              <h2>Image (normal)</h2>
              <div class="modal-image"
                   v-bind:style="{ backgroundImage: getImage(item.image) }">
                <label :for="'logo-normal-' + index"
                       class="step-item-upload"></label>
                <input type="file"
                       @change="onFileChange($event, item, 'image')"
                       :id="'logo-normal-' + index" />
              </div>
              <input type="text" v-model="item.altImage" placeholder="Image alt" />
            </div>
            <div class="modal-item">
              <h2>Image (high contrast)</h2>
              <div class="modal-image"
                   v-bind:style="{ backgroundImage: getImage(item.imageHigh) }">
                <label :for="'logo-high-' + index"
                       class="step-item-upload"></label>
                <input type="file"
                       @change="onFileChange($event, item, 'imageHigh')"
                       :id="'logo-high-' + index" />
              </div>
              <input type="text" v-model="item.altImageHigh" placeholder="High contrast image alt" />
            </div>
            <div class="logo-url">
              <input placeholder="url" v-model="item.url" />
            </div>
            <div class="landing-page-remove"
                 v-if="pageEditMode && isGM()"
                 @click.prevent="removeSection(content.clientSection.logos, index)"></div>
          </div>
          <div class="landing-page-add-section"
               @click.prevent="addSection('logos')"
               v-if="pageEditMode && isGM()">+ Add row</div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="landing-page-change-image" v-if="pageMetaEdit && isGM()">
      <div class="modal-inner" ref="metaEditPopup">
        <h1>Change page meta</h1>
        <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
        <div class="popup-footer-edit">
          <div>
            <div class="meta-description">
              <label for="meta-title">Title</label>
              <input id="meta-title"
                     placeholder="Page meta title"
                     v-model="metaData.title" />
            </div>
            <div class="meta-description">
              <label for="meta-description">Description</label>
              <textarea id="meta-description"
                        placeholder="Page meta description"
                        v-model="metaData.description">{{ metaData.description }}</textarea>
            </div>
          </div>
        </div>
        <div class="popup-actions">
          <a href="#" @click.prevent="closePopup()" class="discard">Discard</a>
          <a href="#" @click.prevent="updateMeta()" class="submit">Save</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/api'
  import Slick from 'vue-slick'

  export default {
    name: 'clearkit-page',
    data () {
      return {
        pageEditMode: false,
        landingPanel: false,
        pageMetaEdit: false,
        editHistory: false,
        pageVersions: [],
        metaData: {
          title: '',
          description: ''
        },
        content: {
          title: '',
          description: '',
          heroSection: {
            title: '',
            description: '',
            button: {
              text: '',
              url: ''
            },
            hideSection: false
          },
          aboutSection: [
            {
              title: '',
              text: '',
              button: {
                text: '',
                url: ''
              },
              hideSection: false
            },
            {
              title: '',
              text: '',
              button: {
                text: '',
                url: ''
              }
            }
          ],
          clientSection: {
            title: '',
            description: '',
            logos: [
              {
                image: '',
                altImage: '',
                imageHigh: '',
                altImageHigh: '',
                url: ''
              }
            ],
            hideSection: false
          },
          howItWorksSection: {
            title: '',
            sections: [
              {
                title: '',
                description: '',
                image: '',
                altImage: '',
                imageHigh: '',
                altImageHigh: ''
              },
              {
                title: '',
                description: '',
                image: '',
                altImage: '',
                imageHigh: '',
                altImageHigh: ''
              },
              {
                title: '',
                description: '',
                image: '',
                altImage: '',
                imageHigh: '',
                altImageHigh: ''
              },
              {
                title: '',
                description: '',
                image: '',
                altImage: '',
                imageHigh: '',
                altImageHigh: ''
              }
            ],
            hideSection: false
          },
          subscribeSection: {
            title: '',
            description: '',
            hideSection: false
          },
          featuresSection: {
            items: [
              {
                title: '',
                description: '',
                button: {
                  text: '',
                  url: ''
                },
                video: '',
                image: '',
                altImage: ''
              }
            ],
            hideSection: false
          },
          footerCTASection: {
            title: '',
            description: '',
            button: {
              text: '',
              url: ''
            },
            hideSection: false
          }
        },
        windowWidth: window.innerWidth,
        serverValidation: {
          errors: []
        },
        disableAPI: false,
        slidesReady: false,
        slickOptions: {
          arrows: false,
          dots: true,
          autoplay: true,
          autoplaySpeed: 5000,
          infinite: true,
          speed: 300,
          slidesToShow: 7,
          slidesToScroll: 7,
          responsive: [
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4
              }
            }
          ]
        },
        slickOptionsContent: {
          arrows: false,
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1
        },
        activePopup: null,
        sliderModalShown: false,
        subscribeForm: {
          isError: false,
          firstnameFocus: false,
          lastnameFocus: false,
          emailFocus: false,
          firstname: '',
          lastname: '',
          email: ''
        }
      }
    },
    computed: {
      ...mapGetters([
        'getIsLoggedIn',
        'getUserRole',
        'selectedHightCont',
        'getSelectedFontSize'
      ])
    },
    methods: {
      ...mapActions([
        'redirect',
        'getRoles',
        'setFontSizeActive',
        'setColorPaletteActive'
      ]),
      updateLandingPage () {
        if (this.disableAPI) return
        let body = JSON.stringify(this.content)
        let pageData = {
          slug: 'clear-kit',
          body: body
        }
        this.disableAPI = true
        this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
          this.disableAPI = false
          this.getLandingPage()
        }).catch((err) => {
          this.disableAPI = false
          console.log('err', err)
        })
      },
      updateMeta () {
        if (this.disableAPI) return
        let metaTitle = this.metaData.title
        let metaDescription = this.metaData.description
        let pageData = {
          title: metaTitle,
          slug: 'clear-kit',
          description: metaDescription
        }
        this.disableAPI = true
        this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
          this.disableAPI = false
          document.location.reload()
        }).catch((err) => {
          this.disableAPI = false
          console.log('err', err)
        })
      },
      getLandingPage (id) {
        if (this.disableAPI) return
        this.disableAPI = true
        this.slidesReady = false
        let body = {
          slug: 'clear-kit'
        }
        if (id) {
          body.id = id
        }
        this.$http.post(api.URLS.staticpage + '/clear-kit', body, api.headersAuthSettings).then((res) => {
          this.disableAPI = false
          let pageData = JSON.parse(res.data.body)
          this.content = pageData
          this.metaData.title = res.data.title
          this.metaData.description = res.data.description
          if (this.metaData.title && this.metaData.title !== '') {
            document.title = this.metaData.title + ' | Clear Assured'
          }
          this.addPageMeta('description', [{name: 'content', value: this.metaData.description}])
          this.content.title = this.metaData.title
          this.content.description = this.metaData.description
          this.slidesReady = true
          this.$nextTick(() => {
            this.$refs.slick.reSlick()
          })
          if (id) {
            this.pageEditSwitch()
          } else {
            this.pageEditMode = false
          }
          this.$store.commit('setUserDimensions')
          if (window._paq) {
            window._paq.push(['setCustomUrl', location.pathname])
            window._paq.push(['setDocumentTitle', document.title])
            window._paq.push(['trackPageView'])
          }
          // if (window.ga) {
          //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name.includes('edit') ? 'ADMINISTRATION_AREA' : 'PUBLIC_PAGE')
          //   window.ga('send', 'pageview', {
          //     'page': location.pathname,
          //     'location': location.href,
          //     'title': document.title
          //   })
          // }
        }).catch((err) => {
          this.disableAPI = false
          console.log('err', err)
        })
      },
      getPageVersions () {
        let self = this
        if (this.disableAPI) return
        this.disableAPI = true
        this.$http.get(api.URLS.staticpagechanges + '/clear-kit', api.headersAuthSettings).then((res) => {
          this.disableAPI = false
          this.pageVersions = []
          for (let index in res.body) {
            self.pageVersions.push({
              label: self.convertDateTime(res.body[index].createdAt),
              id: res.body[index].id
            })
          }
          this.editHistory = true
        }).catch((err) => {
          this.disableAPI = false
          console.log('err', err)
        })
      },
      activateEditHistory () {
        this.getPageVersions()
      },
      getPageVersionsForSelect () {
        return this.pageVersions
      },
      changeLandingPage (el) {
        this.getLandingPage(el.id)
      },
      convertDateTime (payload) {
        if (!payload) return
        let date = new Date(payload)
        let fullYear = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        let hours = date.getHours()
        let minutes = date.getMinutes()
        let ampm = hours >= 12 ? 'PM' : 'AM'
        let newHours = hours % 12 ? hours % 12 : 12
        function toDoubleDigit (num) {
          return num.toString().length < 2 ? '0' + num : num.toString()
        }
        let dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear
        let timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm
        return dateString + ' ' + timeString
      },
      addPageMeta (name, data) {
        let meta = document.createElement('meta')
        meta.name = name
        for (let index in data) {
          meta.setAttribute(data[index].name, data[index].value)
        }
        document.getElementsByTagName('head')[0].appendChild(meta)
      },
      discardChanges () {
        this.getLandingPage()
      },
      pageEditSwitch () {
        this.pageEditMode = true
        this.$nextTick(() => {
          this.autoSizeOnInit()
        })
      },
      discardPageEdit () {
        this.discardChanges()
        if (this.editHistory) {
          this.editHistory = false
        } else {
          this.landingPanel = false
        }
      },
      addSection (section) {
        if (section === 'features') {
          this.content.featuresSection.items.push({
            title: '',
            text: '',
            video: '',
            button: {
              text: '',
              url: ''
            },
            image: '',
            altImage: ''
          })
        }
        if (section === 'logos') {
          this.content.clientSection.logos.push({
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: '',
            url: ''
          })
        }
      },
      removeSection (section, index) {
        section.splice(index, 1)
      },
      onFileChange (e, target, item) {
        var input = e.target
        let self = this
        if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
          var reader = new FileReader()
          reader.onload = function (e) {
            let fileName = input.files[0].name
            let extension = fileName.split('.').pop().toLowerCase()
            if (self.disableAPI) return
            let pageData = {
              file: e.target.result,
              extension: extension
            }
            self.disableAPI = true
            self.$http.post(api.URLS.uploadFile, pageData, api.headersAuthSettings).then((res) => {
              self.disableAPI = false
              target[item] = res.body
            }).catch((err) => {
              self.disableAPI = false
              console.log('err', err)
            })
          }
          reader.readAsDataURL(input.files[0])
        }
      },
      getImagePath () {
        return api.serverURL + '/uploads/images/content/'
      },
      isBase64 (payload) {
        return payload.indexOf('data:') !== -1
      },
      getImage (payload) {
        if (!payload) {
          return ''
        }
        return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')'
      },
      getImageFullPath (payload) {
        if (!payload) {
          return ''
        }
        return this.isBase64(payload) ? payload : this.getImagePath() + payload
      },
      getHighImage (item) {
        return this.selectedHightCont === 1 ? item.imageHigh : item.image
      },
      getHighImageAlt (item) {
        return this.selectedHightCont === 1 ? item.altImageHigh : item.altImage
      },
      activatePopup (item) {
        this.activePopup = item
      },
      closePopup () {
        this.activePopup = null
        this.sliderModalShown = false
        this.slidesReady = true
        this.pageMetaEdit = false
        this.$nextTick(() => {
          this.$refs.slick.reSlick()
        })
      },
      closePopupOnOutsideClick (e) {
        let iconPopup = this.$refs.iconPopup
        let sliderPopup = this.$refs.sliderPopup
        let target = e.target
        if (iconPopup && iconPopup !== target && !iconPopup.contains(target)) {
          this.activePopup = null
        }
        if (sliderPopup && sliderPopup !== target && !sliderPopup.contains(target)) {
          this.switchSliderModal()
          this.slidesReady = true
          this.$nextTick(() => {
            this.$refs.slick.reSlick()
          })
        }
      },
      getVideoUrl (url) {
        let link = url
        if (url !== '') {
          let linkPart = url.split('/')
          if (linkPart) {
            if (linkPart[2].indexOf('youtu') !== -1) {
              link = `${linkPart[0]}//www.youtube.com/embed/${linkPart[linkPart.length - 1]}`
            }
            if (linkPart[2].indexOf('vimeo') !== -1) {
              link = `${linkPart[0]}//player.vimeo.com/video/${linkPart[linkPart.length - 1]}`
            }
            link += '?autoplay=0&loop=1'
          }
        }
        return link
      },
      switchSliderModal () {
        this.sliderModalShown = !this.sliderModalShown
      },
      autoSize (el) {
        setTimeout(function () {
          el.target.style = 'height:auto; padding:0'
          el.target.style = 'height:' + el.target.scrollHeight + 'px'
        }, 0)
      },
      autoSizeOnInit () {
        let textAreas = document.getElementsByTagName('textarea')
        for (let i = 0; i < textAreas.length; i++) {
          let item = textAreas[i]
          setTimeout(function () {
            item.style = 'height:auto; padding:0'
            item.style = 'height:' + item.scrollHeight + 'px'
          }, 0)
        }
      },
      isGM () {
        let isLogged = this.getIsLoggedIn
        if (!isLogged) {
          return false
        }
        let userRole = this.getUserRole
        if (userRole === 'gm') {
          return true
        }
        return false
      },
      handleWindowResize (event) {
        this.windowWidth = event.currentTarget.innerWidth
      },
      getDeviceType (check) {
        let width = this.windowWidth
        let deviceName = ''
        if (width > 1024) {
          deviceName = 'desktop'
        } else if (width > 640) {
          deviceName = 'tablet'
        } else {
          deviceName = 'mobile'
        }
        return check === deviceName
      },
      subscribeMe () {
        let firstname = this.subscribeForm.firstname
        let lastname = this.subscribeForm.lastname
        let email = this.subscribeForm.email
        let body = {
          firstname: firstname,
          lastname: lastname
        }
        this.$http.post(api.URLS.subscribe + '/' + email, body, api.headersAuthSettings).then((res) => {
          this.subscribeForm.firstname = ''
          this.subscribeForm.lastname = ''
          this.subscribeForm.email = ''
          this.subscribeForm.isError = false
        }).catch((err) => {
          this.subscribeForm.isError = true
          console.log('err', err)
        })
      }
    },
    created () {
      this.getLandingPage()
    },
    mounted () {
      this.setFontSizeActive()
      this.setColorPaletteActive()
      window.addEventListener('resize', this.handleWindowResize)
      document.addEventListener('click', this.closePopupOnOutsideClick)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.handleWindowResize)
      document.addEventListener('click', this.closePopupOnOutsideClick)
    },
    components: {
      Slick
    },
    watch: {}
  }
</script>

<style src="@/assets/scss/main/homepage.scss" lang="scss" scoped></style>
<style src="@/assets/scss/components/slick.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// ClearKit.vue?711c8f14